import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Wrapper from 'common/navigation/wrapper';
import MultipleDetails from './details/containers/multiple-details-container';

const OrderRoutes = () => {
  const params = useParams();
  const navigate = useNavigate();
  const ids = params.orderIds.split(',')?.map(o =>
    decodeURIComponent(o));
  const currentPosition = params.currentposition ?
    parseInt(params.currentposition, 10) :
    0;
  // Firefox workaround
  if (!params['*']) {
    navigate('dashboard');
  }
  return (
    <Wrapper>
      <MultipleDetails
        orderIds={ids}
        currentPosition={currentPosition}
      />
    </Wrapper>
  );
};

OrderRoutes.propTypes = {};

export default OrderRoutes;
